/** @type {import('tailwindcss').Config} */
import colors from 'tailwindcss/colors.js';
delete colors['lightBlue'];
delete colors['warmGray'];
delete colors['trueGray'];
delete colors['coolGray'];
delete colors['blueGray'];

import theme from 'tailwindcss/defaultTheme.js';

export default {
	content: [],
	theme: {
		colors: {
			...colors,
			blackAlmost: '#4D4D4D',
			yello: {
				100: '#fff6bf',
			},
			grey: {
				100: "#F3F3F3",
				300: "#efefef",
				400: "#cdcfcd",
				500: "#B0B0B0",
				600: "#4d4d4d",
				700: "#1d1d1d",
			},
			primary: {
				200: '#F0513B',
				500: '#F0513B',
				800: '#91190A',
			},
			secondary: {
				300: "#4DA9AD",
				500: "#4DA9AD",
			},

			'admin-white': "#FFF",
			'admin-text': "#141517",
			'admin-links': "#F0513B",
			'admin-panel-bg': "#f5f5f5",
			'admin-text-grey': "#9A9A9A",

			'admin-menu': "#111111",
			'admin-menu-bg': "#F0513B",
			'admin-menu-hr': "#E3EFFF",

			'admin-table-border': "#e5eae9",
			'admin-table-highlight': "#f5f5f5",
			'admin-table-bg-header': "#ff7777",

			'admin-input-icon': '#6A6A6A',
			'admin-input-text': '#141517',
			'admin-input-border': '#cdcfcd',
			'admin-input-bg': '#f5f5f5',

			'admin-input-border-highlight': '#F0513B',
			'admin-input-bg-highlight': '#ff7777',

			'admin-input-border-disabled': '#ADADAD',
			'admin-input-bg-disabled': '#e5eae9',
			'admin-input-text-disabled': '#9A9A9A',
		},
		fontFamily: {
			...theme.fontFamily,
			avenir: "Avenir, 'Avenir Next LT Pro', Montserrat, Corbel, 'URW Gothic', source-sans-pro, sans-serif",
			arial: 'Arial, Helvetica, sans-serif',
			century: '"Century Gothic", CenturyGothic, AppleGothic, sans-serif',
			futura: '"Futura LT", Futura, "Trebuchet MS", Arial, Helvetica, sans-serif',
			helvetica: '"Helvetica Neue", Arial, Helvetica, sans-serif',
			helveticaLight: '"HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Arial, Helvetica, sans-serif',
			geneva: 'Geneva, Tahoma, Verdana, sans-serif',
			georgia: 'Georgia, Palatino, "Palatino Linotype", "Times New Roman", serif',
			goudy: '"Goudy Old Style", Georgia, "Times New Roman", serif',
			palatino: 'Palatino, Palatino Linotype, Palatino LT STD, Book Antiqua, Georgia, serif',
			tahoma: 'Tahoma, Geneva, Verdana, sans-serif',
			times: 'TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia, serif',
			verdana: 'Verdana, Geneva, Tahoma, sans-serif',
			mono: ['ui-monospace', 'Menlo', 'Consolas', 'monospace'],
		},
		screens: {
			...theme.screens,
			sm: '480px',
			xl: '1440px',
			xxl: '1441px',
			'2xl': '1920px',
			'3xl': '1920px'
		},
		extend: {
			scale: {
				'33': '0.3333',
				'25': '0.25',
				'200': '2.0',
			},
			spacing: {
				'128': '32rem',
			},
			zIndex: {
				'60': '60',
				'70': '70',
				'80': '80',
				'90': '90',
				'100': '100',
			},
			order: {
				'13': '13',
				'14': '14',
				'15': '15',
				'16': '16',
			},
			animation:{
				'shake': 'shake 0.82s cubic-bezier(.36,.07,.19,.97) both',
				'bounce-mine': 'bounce-mine 3s infinite',
			},
			keyframes: {
				'shake' : {
					'10%, 90%': {
						transform: 'translateX(-2px)'
					},
					'20%, 80%' : {
						transform: 'translateX(4px)'
					},
					'30%, 50%, 70%': {
						transform: 'translateX(-8px)'
					},
					'40%, 60%': {
						transform: 'translateX(8px)'
					}
				},
				'bounce-mine': {
					'0%, 50%': {
						transform: 'translateY(-15%)',
						animationTimingFunction: 'cubic-bezier(0.8,0,1,1)',
					},
					'25%': {
						transform: 'none',
						animationTimingFunction: 'cubic-bezier(0,0,0.2,1)',
					},
					'50%, 100%': {
						transform: 'translateY(-15%)',
					}
				},
			}
		},
		borderRadius: {
			...theme.borderRadius,
			'sm': '0.1875rem',
		}
	},
}
